module.exports = __webpack_public_path__ + "img/logo-login.19dc5861.png";